import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_027",
  "use": "icon-su_027-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-su_027\"><defs><style>#icon-su_027 .cls-1{fill:#fff;}#icon-su_027 .cls-2{fill:#d4d4d4;}</style></defs><g id=\"icon-su_027_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_027_icon\"><circle class=\"cls-1\" cx=\"10\" cy=\"10\" r=\"9.5\" /><path class=\"cls-2\" d=\"M10,1a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-1A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol